import barba from '@barba/core';
import { gsap } from "gsap";
import { SplitText } from "gsap/SplitText";

gsap.registerPlugin(SplitText);



function initNav()
{
    const $bodyElement = document.querySelector('body');
    const $navigationOpenElement = document.querySelector('[navigation-toggle]');
    const $navigationCloseElement = document.querySelector('[navigation-close]');
    const $siteNavigationElement = document.querySelector('[navigation-container]');

    if ($navigationOpenElement != null && $navigationCloseElement != null)
    {
        $navigationOpenElement.addEventListener("click", toggleNavigation);
        $navigationCloseElement.addEventListener("click", toggleNavigation);

        // Reset state
        $bodyElement.classList.remove("navigation--open");
        $siteNavigationElement.classList.remove("siteNavigation--state-open");
    }
}

function resetNav()
{
    const $bodyElement = document.querySelector('body');
    const $siteNavigationElement = document.querySelector('[navigation-container]');
    const $navigationOpenElement = document.querySelector('[navigation-toggle]');
    const $navigationCloseElement = document.querySelector('[navigation-close]');

    // Reset state
    $bodyElement.classList.remove("navigation--open");

    if ($siteNavigationElement != null)
    {
        $siteNavigationElement.classList.remove("siteNavigation--state-open");
        $siteNavigationElement.removeAttribute("style");
        $navigationOpenElement.removeEventListener("click", toggleNavigation);
        $navigationCloseElement.removeEventListener("click", toggleNavigation);
    }
}

function toggleNavigation()
{
    const $bodyElement = document.querySelector('body');
    const $siteNavigationElement = document.querySelector('[navigation-container]');

    const viewportWidth = window.innerWidth;
    const viewportHeight = window.innerHeight;

    const $logoPeriod = document.getElementById("logo_period");
    const logoPeriodLocation = $logoPeriod.getBoundingClientRect();
    
    const periodOffsetX = 2;
    const periodOffsetY = 2;
    const periodLeft = logoPeriodLocation.left + periodOffsetX;
    const periodTop = logoPeriodLocation.top + periodOffsetY;

    const leftPercent = periodLeft / viewportWidth * 100;
    const topPercent = periodTop / viewportHeight * 100;

    const $navLinks = $siteNavigationElement.querySelectorAll('.siteNavigation__primaryLinks-link');

    if ($bodyElement.classList.contains('navigation--open'))
    {
        document.removeEventListener("keydown", closeOnEscape);

        const clipPathStart = "circle(140% at " + leftPercent + "% " + topPercent + "%)";
        const clipPathEnd = "circle(0% at " + leftPercent + "% " + topPercent + "%)";

        gsap.fromTo($siteNavigationElement, {clipPath: clipPathStart}, {clipPath: clipPathEnd, ease: "power4.inOut", duration: 0.7, onComplete: () => {
            $bodyElement.classList.remove("navigation--open");
            $siteNavigationElement.classList.remove("siteNavigation--state-open");
            $siteNavigationElement.removeAttribute("style");
        }});
    }
    else
    {
        document.addEventListener("keydown", closeOnEscape);

        $bodyElement.classList.add("navigation--open");
        $siteNavigationElement.classList.add("siteNavigation--state-open");

        const clipPathStart = "circle(0% at " + leftPercent + "% " + topPercent + "%)";
        const clipPathEnd = "circle(140% at " + leftPercent + "% " + topPercent + "%)";

        gsap.fromTo($siteNavigationElement, {clipPath: clipPathStart}, {clipPath: clipPathEnd, ease: "power4.inOut", duration: 0.85});

        [...$navLinks].forEach((element, index) => {
            const delay = (0.1 * index) + 0.2;

            element.split = new SplitText(element, { 
                type: "lines,words,chars",
                linesClass: "split-line",
                wordsClass: "split-word",
                charsClass: "split-char"
            });

            gsap.from(element.split.chars, { delay: delay, duration: 0.4, opacity: 0, y: "4vw", ease: "back(3)", stagger: {from: "start", each: 0.04}});
        });
    }
}

function closeOnEscape(e)
{
    if (e.which == 27)
    {
        toggleNavigation();
    }
}


barba.hooks.enter((data) => {

    resetNav();
    initNav();

});


initNav();